import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { Hook } from './components/Hook';
import { Benefits } from './components/Benefits';
import { Modules } from './components/Modules';
import { Gallery } from './components/Gallery';
import { Creator } from './components/Creator';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { initPixel, trackPageView, PIXEL_NOSCRIPT_URL } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-caramel/30 selection:text-espresso" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={PIXEL_NOSCRIPT_URL} alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <TrustBadges data-id="element-4" />
      <Hook data-id="element-5" />
      <Benefits data-id="element-6" />
      <Modules data-id="element-7" />
      <Gallery data-id="element-8" />
      <Creator data-id="element-9" />
      <Testimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <Offer data-id="element-12" />
      <FAQ data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}